import {
  QuestionnaireFormProps,
  QuestionnaireQuestions,
} from '@getpopsure/qnr-framework';
import { BaseQuestionnaire } from 'features/generalQuestionnaire/generalPolicy/actions';
import hashSum from 'hash-sum';
import { Policy } from 'models/policies';
import { useEffect, useState } from 'react';

import {
  AdjustPolicyConfig,
  AdjustPolicyReturnValue,
  BaseQuote,
} from '../../models';
import { AdjustPolicyView } from './AdjustPolicy.view';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const PreviewAdjustPolicy = <
  Questionnaire extends QuestionnaireQuestions
>(
  props: QuestionnaireFormProps<Questionnaire, AdjustPolicyReturnValue> &
    AdjustPolicyConfig & {
      configuration: {
        policy: Policy;
        policyQuestionnaire: BaseQuestionnaire;
        policyQuote: BaseQuote;
      };
    }
) => {
  const {
    questionnaireAnswers,
    configuration: { policyQuestionnaire, policyQuote },
    onSubmitValue,
  } = props;

  const flattenedOriginalAnswers = {
    ...policyQuestionnaire?.answers.personalInfo,
    ...policyQuestionnaire?.answers.tariffInfo,
  };

  const [optionValues, setOptionValues] =
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    useState<Record<string, any>>(questionnaireAnswers);

  const reset = () => setOptionValues(flattenedOriginalAnswers);

  useEffect(() => {
    if (
      Object.entries(optionValues).length === 0 &&
      Object.entries(flattenedOriginalAnswers).length > 0
    ) {
      setOptionValues(flattenedOriginalAnswers);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [flattenedOriginalAnswers]);

  const hasChangedOptions =
    hashSum(flattenedOriginalAnswers) !== hashSum(optionValues);

  const mockQuotes = [
    {
      price: hasChangedOptions ? 4.98 : 8.94,
    },
  ];

  const handleSubmit = () => {
    onSubmitValue({
      ...optionValues,
      reviewMonthlyPrice: mockQuotes?.[0].price,
      questionnaireTransform: {
        personalInfo: Object.keys(
          policyQuestionnaire?.answers?.personalInfo ?? {}
        ),
        tariffInfo: Object.keys(policyQuestionnaire?.answers?.tariffInfo ?? {}),
      },
    });
  };

  return (
    <AdjustPolicyView
      handleSubmit={handleSubmit}
      setOptionValues={setOptionValues}
      optionValues={optionValues}
      newPrice={mockQuotes?.[0].price || 0}
      oldPrice={policyQuote?.price || 0}
      reset={reset}
      hasChangedOptions={hasChangedOptions}
      {...props}
    />
  );
};
